import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Icon, Snackbar } from '@gympass/yoga';
import { Copy } from '@gympass/yoga-icons';

import * as S from './style';

interface CopyBoxProps {
  content: string;
}

export default function CopyBox({ content }: CopyBoxProps) {
  const { t } = useTranslation();
  const [showSnackbar, setShowSnackbar] = useState(false);

  const saveToClipBoard = () => {
    navigator.clipboard.writeText(content);
    setShowSnackbar(true);
  };

  return (
    <>
      <S.CopyContainer>
        <Text.H4 fontWeight="medium">{content}</Text.H4>
        <S.IconWrapper role="button" title="Copy" onClick={saveToClipBoard}>
          <Icon as={Copy} width={24} height={24} fill="primary" />
        </S.IconWrapper>
      </S.CopyContainer>

      <Snackbar
        open={showSnackbar}
        variant="success"
        message={t('copy-feedback')}
        duration={3000}
        onClose={() => setShowSnackbar(false)}
        hideCloseButton
      />
    </>
  );
}
